import { Command } from "../command";
import { CommandType } from "../commandType";
import * as $ from "jquery";
import { PopupType } from "../popups/popupType";
import { Application } from "../application";
import * as ko from "knockout";
import {EstimateRenamePopupParams} from "../../components/estimate-rename-popup/estimate-rename-popup";

export class RenameEstimateCommand implements Command {
    constructor(private app: Application) {

    }

    type: CommandType = CommandType.RenameEstimate;
    
    canExecute = ko.computed(() => {
        return true;
    });
    canNotExecute = ko.computed(() => {
        return !this.canExecute();
    });
    
    execute(command: {id: number, name: string }): JQueryPromise<any> {
       
        if (!this.canExecute())
            return $.Deferred().reject().promise();

        let params = <EstimateRenamePopupParams> {
            id: command.id,
            name: command.name
        };
        
        return this.app.popupsManager.show<EstimateRenamePopupParams>(PopupType.estimateRename, true, params).done(() => {
            let estimate = this.app.state.estimate();
            if(estimate && estimate.id() == command.id) {
                estimate.name(params.name);
            }
        });
    }

    name = "Rename estimate";
}


// WEBPACK FOOTER //
// ./ClientApp/services/commands/renameEstimateCommand.ts